import { Link } from '@tanstack/react-router'
import { HomeIcon, UserXIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components'
import { BaseError } from './BaseError'

const MembershipLimitReached = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <BaseError
      title="Membership Limit Reached"
      description="You are already a member of another account and cannot join this one."
      icon={UserXIcon}
      withLogout
      {...props}
      ref={ref}
    >
      <Button asChild>
        <Link to="/">
          <HomeIcon className="size-4" />
          Go home
        </Link>
      </Button>
    </BaseError>
  )
})

MembershipLimitReached.displayName = 'MembershipLimitReached'

export { MembershipLimitReached }
